import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useToast } from "../../../../Context/ToastContext";
import { loadTemplateIntoPipeline } from "./loadTemplateIntoPipeline";
import { PIPELINE_STEPS } from "./salaryTemplatePipeline";
import "../../../../../styles/salary-template-pipeline.css";

/**
 * Loads an existing template into the canonical pipeline and opens step 1.
 * Replaces the legacy Salary Template Builder mapping page for edit.
 */
export default function SalaryTemplatePipelineEntry() {
  const { id } = useParams();
  const navigate = useNavigate();
  const toast = useToast();
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        await loadTemplateIntoPipeline(id);
        if (cancelled) return;
        navigate(`/salary-v2/structures?pipeline=${PIPELINE_STEPS.template}`, { replace: true });
      } catch (e) {
        if (cancelled) return;
        const msg = e?.detail || e?.message || "Could not open salary structure";
        setError(msg);
        toast.error(msg);
        navigate("/salary-v2/structures", { replace: true });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [id, navigate, toast]);

  return (
    <div className="stp-card stp-pipeline-entry-loading">
      {error ? (
        <p className="stp-error">{error}</p>
      ) : (
        <>
          <Loader2 size={28} className="stp-spin" aria-hidden />
          <p>Opening salary structure editor…</p>
        </>
      )}
    </div>
  );
}
